import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';
import { IBranchInspection } from '../interfaces';
import { BranchInspectionMapper } from '../mappers';

export type IGetBranchInspectionByIdRepoResponse = IRepoResponse<200, IBranchInspection> | IRepoResponse<400 | 500, string>;

export type IGetBranchInspectionByIdRepo = IRepo<[string], IGetBranchInspectionByIdRepoResponse>;

export const GetBranchInspectionByIdRepoType = Symbol.for('GetBranchInspectionByIdRepo');

@bind(GetBranchInspectionByIdRepoType)
export class GetBranchInspectionByIdRepo implements IGetBranchInspectionByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker(`/api/admin/branch_inspections/${id}`) });

      if (result.status === 200) {
        const data: IBranchInspection = BranchInspectionMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumat əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
